import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import KnowledgeAssetTagAppResource from './KnowledgeAssetTagAppResource';
import KnowledgeBaseAppResource from './KnowledgeBaseAppResource';
import KnowledgeAssetCategoryAppResource from "./KnowledgeAssetCategoryAppResource";

class KnowledgeAssetVideoAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Knowledge-Asset-Video';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'knowledge/assets/videos';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'publishDate',
            'title',
            'isPublished',
            'meta',
            'knowledgeBaseUuid',
            'description',
            'vimeoLink',
            'thumbnailUrl',
            'knowledgeBase',
            'tags',
            'categories',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            knowledgeBase: KnowledgeBaseAppResource,
            tags: KnowledgeAssetTagAppResource,
            categories: KnowledgeAssetCategoryAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            knowledgeBase: 'knowledge_base_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            publishDate: {
                presence: true,
                datetime: true,
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 2,
                    maximum: 255,
                },
            },
            isPublished: {
                type: 'boolean',
            },
            meta: {},
            knowledgeBaseUuid: {
                type: 'string',
                presence: true,
            },
            description: {
                type: 'string',
            },
            vimeoLink: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            thumbnailUrl: {
                type: 'string',
            },
            tags: {
                type: 'array'
            },
            categories: {
                type: 'array'
            },
        };
    }

    getVimeoLink() {
        if (!this.vimeoLink) {
            return null;
        }

        const vimeoId = this.vimeoLink.match(/\d/g).join("");

        return `https://player.vimeo.com/video/${vimeoId}?portrait=0&byline=0&title=0`;
    }
}

export default KnowledgeAssetVideoAppResource;
